import styled, { keyframes } from 'styled-components';

const PopInAnimationToast = keyframes`
  0% { transform: translateY(-100px); opacity: 0; }
  50% { transform: translateY(20px); opacity: 1; }
  85% { transform: translateY(20px); opacity: 1; }
`;

export const PostElectionToastStyled = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 9999;
  width: auto;
  max-width: 90vw;
  min-width: 280px;
  box-sizing: border-box;

  animation: ${PopInAnimationToast};
  animation-delay: 200ms;
  animation-timing-function: ease-out;
  animation-duration: 5000ms;

  @media (max-width: 768px) {
    left: 16px;
    right: 16px;
    width: calc(100% - 32px);
    margin: 0 auto;
  }

  .MuiAlert-root {
    width: 100%;
    word-break: break-word;
    white-space: normal;
    font-size: 14px;
  }
`;